import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { apiGet, apiPost } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import { inRange, isEmpty, lowerCase } from "lodash";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../context/AuthContext";
import { useTranslation } from "react-i18next";
import iconBkash from "../../assets/images/bkash.png";
import iconRocket from "../../assets/images/rocket.png";
import iconNagad from "../../assets/images/nagad.png";
import iconEth from "../../assets/images/eth.svg";
import iconBtc from "../../assets/images/btc.svg";
import iconUpay from "../../assets/images/upay.png";
import iconTrc20 from "../../assets/images/trc20.svg";
import { Form } from "react-bootstrap";
import { formatWithCommas, validationRules, bankType } from "../../Utils/Toast";
import InternalLoader from "../../component/InternalLoader";
import { FaRegCopy } from "react-icons/fa";

const Deposit = () => {
  const naviagte = useNavigate();
  let location = useLocation();
  const { offerCode } = useParams();
  const {
    register,
    handleSubmit,
    reset,
    getValues,
    setValue,
    clearErrors,
    watch,
    control,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    shouldFocusError: true,
    defaultValues: {
      depositType: "online",
    },
  });
 
  const [image, setImage] = useState("");
  const [dataOffer, setDataOffer] = useState([]);
  const [bank, setBank] = useState([]);
  const [bankId, setBankId] = useState("");
  const { t } = useTranslation();
  const [fiexdOffer, setFixedOffer] = useState(0);
  const [isCopied, setCopied] = useState(false);
  const [minDeposit, setMinDeposit] = useState(100);
  const [maxDeposit, setMaxDeposit] = useState(25000);
  const profileData = useContextSelector(AuthContext, (ctx) => ctx.profileData);
  const amountDeposit = useContextSelector(
    AuthContext,
    (ctx) => ctx.amountDeposit
  );
  const [isLoader, setLoader] = useState(false);
  const [offer, setOffer] = useState("");
  const [limit, setLimit] = useState(
    profileData?.limitSetting?.length > 0
      ? profileData?.limitSetting[0]
      : {
        minDeposit: "100",
        maxDeposit: "30000",
      }
  );
   const [paymentType, setPaymentType] = useState("offline");

  useEffect(() => {
    if (profileData.defaultPaymentType) {
      setPaymentType(profileData.defaultPaymentType);
    }
  }, [profileData.defaultPaymentType]);

  const [selectedMethod, setSelectedMethod] = useState("");


  useEffect(() => {
    if (paymentType === "online") {
      const defaultMethod = bankType.find(
        (m) => m.bank_name.toLowerCase() === "bkash"
      );

      if (defaultMethod) {
        setSelectedMethod(defaultMethod.bank_name);
        setValue("bank", defaultMethod._id); // react-hook-form
      }
    }
  }, [paymentType, setValue]);
// console.log("paymentType",paymentType);
  const onSubmit = async (body) => {
    setLoader(true);

    try {
      let imageCheck = "";

      if (image) {
        imageCheck = await uploadImage(image);
      }

      const payload = {
        depositType: paymentType,
        amount: body?.amount,
        offer: offer,
        bank: bankId,
        AccountName: body?.accountName,
        BankAccount: body?.bankAccount,
      };

      if (paymentType === "online") {
        payload.transactionType = selectedMethod.toUpperCase();
        payload.payin = true;
      } else {
        payload.transactionType = paymentType;
        payload.TransactionId = body?.transactionId;
        payload.TransactionFile = image ? imageCheck : "";
      }
      // console.log(payload,"payload");
      const { status, data } = await apiPost(apiPath.depositAmount, payload);

      if (status !== 200) {
        return toast.error(data?.message || "Something went wrong");
      }

      // Online Payment
      if (
        paymentType === "online" &&
        data?.results?.payment_url
      ) {
        window.location.href = data.results.payment_url;
        return;
      }

      // Offline Payment
      if (data?.results) {
        toast.success(data?.message);
        //amounutRefresh();
        //getProfileData();
        setImage("");
        reset();
      } else {
        toast.error(data?.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong");
    } finally {
      setLoader(false);
    }
  };

  const getBank = async () => {
    const { status, data } = await apiPost(apiPath.getBank, {
      type: "deposit",
    });
    if (status == 200) {
      if (data?.success) {
        setBank(
          paymentType === "online"
            ? bankType
            : data?.results?.bankList || []
        );
        if (data?.results?.bankList?.length > 0) {
          getBankDetail(data?.results?.bankList[0]?._id);
        }
      }
    }
  };
  const getBankDetail = async (body) => {
    setBankId(body);
    const { status, data } = await apiPost(apiPath.getBankDetail, {
      bank: body,
    });
    if (status == 200) {
      if (data?.success) {
        setValue("accountName", data?.results?.bankDetail?.account_name);
        setValue("bankAccount", data?.results?.bankDetail?.account_number);
      }
    }
  };

  const uploadImage = async (obj) => {
    let form = new FormData();
    form.append("TransactionFile", obj);
    const { status, data } = await apiPost(apiPath.reciptUpload, form);
    if (status == 200) {
      return data?.path;
    } else {
      return false;
    }
  };
 useEffect(() => {
    if (paymentType) {
      getBank();
    }
   
  }, [paymentType]);

  useEffect(() => {
    if (amountDeposit?.check && amountDeposit?.amount > 0) {
      setValue("amount", amountDeposit?.amount);
    }
  }, [amountDeposit?.check]);

  let priceValue = 0;
  const priceCalculate = async (price) => {
    priceValue += price;
    setValue("amount", priceValue);

    const matchedOffer = dataOffer?.find((res) => res?._id == offer);

    if (matchedOffer?.variation?.length) {
      const match = matchedOffer.variation.find((item) => {
        const min = parseFloat(item.depositeVaritationMin);
        const max = parseFloat(item.depositeVaritationMax);
        return priceValue >= min && priceValue <= max;
      });

      if (match) {
        setFixedOffer(match.depositeVaritationPercentage);
      } else {
        setFixedOffer(0);
      }
    }
  };

  useEffect(() => {
    if (offer) {
      priceCalculate(getValues("amount"));
    }
  }, [offer]);

  const resetPrice = async () => {
    setValue("amount", "");
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setCopied(false);
    }, 3000);

    return () => clearTimeout(timeout);
  }, [isCopied]);

  // useEffect(() => {
  //   if (!isEmpty(profileData) && profileData?.limitSetting.length > 0) {
  //     setMinDeposit(
  //       profileData?.limitSetting.length > 0 &&
  //       profileData?.limitSetting[0]?.minDeposit
  //     );
  //     setMaxDeposit(
  //       profileData?.limitSetting.length > 0 &&
  //       profileData?.limitSetting[0]?.maxDeposit
  //     );
  //   }
  // }, [!isEmpty(profileData)]);
  const getFilteredOfferList = (count, list) => {
    const depositKeysToRemove = [
      "OnFirstDeposit",
      "OnSecondDeposit",
      "OnThirdDeposit",
      "OneFourthDeposit",
    ];

    const keysToRemove = depositKeysToRemove.slice(0, count);
    return list.filter((offer) => !keysToRemove.includes(offer.offerOn));
  };

  const getData = async () => {
    const { status, data } = await apiGet(apiPath.getPromotional, {
      category: "Deposit",
    });
    if (status == 200) {
      if (data?.success) {
        let result = data?.results?.offerList?.filter((res) => {
          return res?.category == "Deposit";
        });
        let updated = getFilteredOfferList(
          profileData?.userDepositCount || 0,
          result
        );
        let find = updated?.find((res) => {
          return res?._id == offerCode;
        });
        if (!isEmpty(find)) {
          setOffer(find?._id);
          // setLimit({
          //   minDeposit: find?.minimumDeposite,
          //   maxDeposit: find?.maximumDeposite,
          // });
        }
        if (updated?.length > 0) {
          setDataOffer(updated);
        }
      }
    }
  };
  useEffect(() => {
    getData();
    setOffer(offerCode);
  }, [offerCode, profileData]);

  const handleCopy = () => {
    navigator.clipboard
      .writeText(watch("bankAccount"))
      .then(() => {
        toast.success("Copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };
  const maskBankAccount = (value = "") => {
    if (!value) return "";
    const first4 = value.slice(0, 4);
    const masked = "*".repeat(Math.max(0, value.length - 4));
    return first4 + masked;
  };
  return (
    <div
      className="v-base v-detail-base fade-enter-done"
      id="mc-animate-container"
    >
      <div className="my-home">
        <Form onSubmit={handleSubmit(onSubmit)} className id="v2-vc-container">
          <div className="mc-header-wrap">
            <div
              id="mc-header"
              className="mc-navbar-blue mc-voucherCenter mc-default-header am-navbar am-navbar-light"
            >
              <div
                onClick={() => naviagte(-1)}
                className="am-navbar-left"
                role="button"
              >
                <span className="am-navbar-left-content">
                  <span className="return_icon">
                    <svg
                      style={{ color: "black" }}
                      className="am-icon am-icon-left am-icon-lg"
                    >
                      <use xlinkHref="#left" />
                    </svg>
                  </span>
                </span>
              </div>
              <div className="am-navbar-title">Deposit</div>
              <div className="am-navbar-right">
                <div className="right-wrapper">
                  <div
                    onClick={() => naviagte("/member/depositRecord")}
                    className="report-icon"
                  >
                    <svg className="am-icon am-icon-voucher_list_b99e1f01 am-icon-md am-navbar-title">
                      <use xlinkHref="#voucher_list_b99e1f01" />
                    </svg>
                  </div>
                  {/* <div className="cs-icon">
                    <svg className="am-icon am-icon-service_c87ca62b am-icon-md am-navbar-title">
                      <use xlinkHref="#service_c87ca62b" />
                    </svg>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="am-whitespace am-whitespace-sm mc-whitespace" />
          </div>
          <div className="vc-scroll-container ">
            <div className="vc-v2-container ">
            <div className=" ranndom-container">
                <div className="vc-v2-title">Deposit Channel</div>
                <div className="min-list vc-v2-method  show-more-container">
                  <ul className="deposite-channel">
                    {/* <li onClick={() => setPaymentType("online")} 
                    className={`change-item-animate NAGAD ${paymentType === "online" ? "ck" : ""
                              }`}>
                      <input
                        type="radio"
                        value="online"
                        checked={paymentType === "online"}
                        onChange={() => setPaymentType("online")}
                      />
                      <label>
                        <span>Sky Pay</span>
                      </label>
                    </li> */}
                    <li onClick={() => setPaymentType("offline")}
                      className={`change-item-animate NAGAD ${paymentType === "offline" ? "ck" : ""
                              }`}>
                      <input
                        type="radio"
                        value="offline"
                        checked={paymentType === "offline"}
                        onChange={() => setPaymentType("offline")}
                      />
                      <label>
                        <span>Auto Pay</span>
                      </label>
                    </li>
                  

                    
                  </ul>
                </div>

                </div>
              <div className=" ranndom-container">
                <div className="vc-v2-title">Deposit Method</div>
                <div className="min-list vc-v2-method  show-more-container">
                  <ul>
                    {bank?.length > 0 &&
                      bank?.map((res) => {
                        return (
                          <li
                            onClick={() => {
                              if (paymentType === "online") {
                                setSelectedMethod(res.bank_name);
                              } else {
                                getBankDetail(res._id);
                                setValue("bank", res?._id);
                                setSelectedMethod(res.bank_name);
                              }

                            }}
                            className={`change-item-animate NAGAD ${selectedMethod === res.bank_name ? "ck" : ""
                              }`}
                          >
                            {selectedMethod === res.bank_name && (
                              <svg className="am-icon am-icon-checked_0a488f7d am-icon-md deposit-list-ck">
                                <use xlinkHref="#checked_0a488f7d" />
                              </svg>
                            )}
                            <div className="deposit-img-new">
                              <img
                                src={
                                  res?.bank_name.toLowerCase().includes("bkash")
                                    ? iconBkash
                                    : res?.bank_name
                                      .toLowerCase()
                                      .includes("nagad")
                                      ? iconNagad
                                      : res?.bank_name
                                        .toLowerCase()
                                        .includes("rocket")
                                        ? iconRocket
                                        : res?.bank_name
                                          .toLowerCase()
                                          .includes("eth")
                                          ? iconEth
                                          : res?.bank_name
                                            .toLowerCase()
                                            .includes("btc")
                                            ? iconBtc
                                            : res?.bank_name
                                              .toLowerCase()
                                              .includes("upay")
                                              ? iconUpay
                                              : iconTrc20
                                }
                                alt
                                style={{ display: "block" }}
                              />
                            </div>
                            <div className="desc-content">
                              <div className="desc-info">
                                <div className="vcn-list-text">
                                  <p>{res?.bank_name}</p>
                                </div>
                              </div>
                            </div>
                          </li>
                        );
                      })}
                  </ul>
                </div>
                <div className="vc-tips">
                  <div className="wysiwyg" style={{ paddingBottom: "0" }}>
                    আপনাকে trxid পূরণ করতে হবে। আপনি যদি রিচার্জটি পূরণ না করেন
                    তবে রিচার্জটি জমা হবে না
                  </div>
                </div>
              </div>
              <div className="vc-v2-space-content vc-v2-space-content" />
              <div className>
                

                {paymentType !== "online" && !isEmpty(bankId) && (
                  <>
                    <div className="ranndom-container">
                      <div className="vc-v2-title pay-name ">Account Name</div>
                      <div className="vc-v2-input no-border">
                        <div className="inputCon">
                          <input
                            type="text"
                            inputMode="text"
                            className="inputBase"
                            placeholder="Bank Account Name"
                            {...register("accountName")}
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                    <div className="ranndom-container">
                      <div className="vc-v2-title pay-name ">
                        {t("Bank_Account")}
                      </div>
                      <div className="vc-v2-input no-border">
                        <div className="inputCon">
                          <input
                            type="text"
                            inputMode="text"
                            className="inputBase"
                            placeholder="Please enter a nickname"
                            disabled
                            value={maskBankAccount(watch("bankAccount"))}
                            {...register("bankAccount")}
                            style={{ paddingLeft: "10px" }}
                          />
                          <FaRegCopy
                            onClick={() => handleCopy()}
                            color="black"
                            size={20}
                            style={{
                              position: "absolute",
                              right: "10px",
                              top: "32%",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                )}

                <div className>
                  <div
                    id="payAmount"
                    style={{ paddingBottom: "0" }}
                    className="ranndom-container vc-v2-amount"
                  >
                    <div className="vc-v2-title  pay-amount">
                      Deposit Amounts
                    </div>
                    <div className="vc-v2-input">
                      <div className="deposit-amount-con">
                        <div className="fixed-money">
                          {AmountArray?.map((res) => {
                            return (
                              <div
                                onClick={() => priceCalculate(res?.amount)}
                                className={`fixed-money-item number-mc ${watch("amount") == res?.amount
                                  ? "money-active"
                                  : ""
                                  }`}
                              >
                                {fiexdOffer > 0 && (
                                  <div class="bonus-tip hasBonus">
                                    + {fiexdOffer}
                                  </div>
                                )}
                                {res?.amount}
                              </div>
                            );
                          })}
                        </div>
                        <div>
                          <div className="inputCon  false ">
                            <i>৳</i>
                            <input
                              type="text"
                              inputMode="decimal"
                              placeholder={`${formatWithCommas(
                                limit?.minDeposit
                              )} - ${formatWithCommas(limit?.maxDeposit)}`}
                              className="inputBase"
                              name="deposit"
                              // onClick={() => resetPrice()}
                              // {...register("amount", {
                              //   required: {
                              //     value: true,
                              //     message: t("Please_enter_amount"),
                              //   },
                              //   validate: (value) => {
                              //     if (value > 0) {
                              //       if (Number(value) > Number(maxDeposit)) {
                              //         return (
                              //           "Amount should not be greater than " +
                              //           maxDeposit
                              //         );
                              //       } else if (
                              //         Number(value) < Number(minDeposit)
                              //       ) {
                              //         return (
                              //           "Deposit Amount Should be greater than " +
                              //           minDeposit
                              //         );
                              //       }
                              //     } else {
                              //       return t("Amount_0");
                              //     }
                              //   },
                              // })}
                              {...register("amount", {
                                required: {
                                  message: "Please enter amount",
                                },
                                pattern: {
                                  value: /^[0-9]*$/,
                                  message: "Please enter valid number",
                                },
                                validate: (value) => {
                                  if (
                                    !inRange(
                                      value,
                                      limit?.minDeposit,
                                      limit?.maxDeposit
                                    )
                                  ) {
                                    return `Deposite amount should be in range of ${limit?.minDeposit} - ${limit?.maxDeposit}`;
                                  } else {
                                    return true;
                                  }
                                },
                              })}
                            />
                          </div>
                          <div
                            className="vc-tips"
                            style={{ paddingTop: "5px" }}
                          >
                            <div
                              className="wysiwyg"
                              style={{ fontSize: "12px", paddingBottom: "0" }}
                            >
                              * Minimum Amount : ৳{formatWithCommas(minDeposit)}
                              ，Maximum Amount : ৳{" "}
                              {formatWithCommas(maxDeposit)}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {paymentType !== "online" && (
                    <>
                      <div className="ranndom-container">
                        <div className="vc-v2-title pay-name ">
                          {t("Upload_Receipt")}
                        </div>
                        <div className="">
                          <input
                            placeholder="Please enter a nickname"
                            type="file"
                            style={{ paddingLeft: "10px" }}
                            accept="image/png, image/jiffy, image/jpeg, image/jpg"
                            onChange={(e) => {
                              setImage(e.target.files[0]);
                            }}
                          />

                          {image !== "" && (
                            <button
                              style={{
                                border: "none",
                                borderRadius: "5px",
                                background: "red",
                                color: "white",
                                padding: "5px",
                                width: "100%",
                                marginTop: "5px",
                                fontWeight: "600",
                                fontSize: "13px",
                              }}
                              onClick={() => setImage("")}
                              type="button"
                            >
                              Remove Image
                            </button>
                          )}
                        </div>
                      </div>
                      <div className="ranndom-container">
                        <div className="vc-v2-title pay-name ">Transaction Id</div>
                        <div className="vc-v2-input">
                          <div
                            style={{ paddingLeft: "10px" }}
                            className="inputCon "
                          >
                            <input
                              type="text"
                              inputMode="text"
                              className="inputBase"
                              placeholder="Transaction Id"
                              style={{ paddingLeft: "0" }}
                              {...register("transactionId", {
                                required: {
                                  value: true,
                                  message: t("enter_Transaction_ID"),
                                },
                                pattern: {
                                  value: validationRules.removeWhitespace,
                                  message: "Please enter only number or character",
                                },
                              })}
                            />
                          </div>

                          {errors?.transactionId?.message && (
                            <div className="vc-tips" style={{ paddingTop: "5px" }}>
                              <div
                                className="wysiwyg"
                                style={{ fontSize: "12px", paddingBottom: "0" }}
                              >
                                * {errors?.transactionId?.message}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </>)}




                  <div
                    className="   ranndom-container vc-v2-space vc-v2-active"
                    id="vc-v2-active"
                  >
                    <div className="vc-v2-title  pay-active">Promotions</div>
                    <div className="vc-v2-active-container normal">
                      <div className="am-flexbox am-flexbox-align-middle deposit-promo-v2 flex-con ">
                        <div className="am-flexbox-item">
                          <div className="act-container">
                            {dataOffer?.map((res, index) => {
                              return (
                                <div
                                  onClick={() => {
                                    setOffer(res?._id); // triggers useEffect
                                    // setLimit({
                                    //   minDeposit: res?.minimumDeposite,
                                    //   maxDeposit: res?.maximumDeposite,
                                    // });
                                  }}
                                  style={{ height: "100%" }}
                                  className={`act-item ${offer == res?._id ? "on" : ""
                                    }`}
                                >
                                  <div className="act-prom-name act-prom-remark-v2-container">
                                    <div className="act-name">{res?.title}</div>
                                    <div className="act-mount">
                                      ≥ <i>৳ {res?.minimumDeposite}</i>
                                    </div>
                                  </div>
                                  <div className="act-prom-remark-v2">
                                    <div className="wysiwyg">
                                      <p>{res?.description.substring(0, 59)}</p>
                                    </div>
                                  </div>
                                  {res?._id == offer && (
                                    <div class="vc-v2-account-info">
                                      <div>
                                        Complete below info to participate the
                                        promotion
                                      </div>
                                      {!isEmpty(offer) && res?._id == offer && (
                                        <div class="task-item done">
                                          <div class="setting-text">
                                            Bind withdrawal account
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </div>
                              );
                            })}
                            <div
                              onClick={() => {
                                setOffer(""); // triggers useEffect
                              }}
                              style={{ height: "100%" }}
                              className={`act-item ${offer == "" ? "on" : ""}`}
                            >
                              <div className="act-prom-name act-prom-remark-v2-container">
                                <div className="act-name">
                                  Do not participate in any promotions
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className=" vc-v2-submit">
            <button
              disabled={isLoader}
              type="submit"
              style={{
                background: "transparent",
                border: "none",
                color: "white",
              }}
            >
              Next
            </button>
          </div>
        </Form>
      </div>{" "}
      {isLoader && <InternalLoader />}
    </div>
  );
};

export default Deposit;
export const AmountArray = [
  { id: 1, amount: 300 },
  { id: 2, amount: 500 },
  { id: 3, amount: 1000 },
  { id: 4, amount: 5000 },
  { id: 5, amount: 15000 },
  { id: 6, amount: 20000 },
  { id: 7, amount: 25000 },
];
